import { Accordion } from "./Accordion";

export class Mainmenu extends Accordion {
    constructor(accordion,{
        accordionActiveClass,
        accordionBodySelector,
        accordionBtnCloseSelector,
        accordionTogglerSelector,
        accordionTogglerActiveClass,
    }, renderer) {
        super(accordion,{accordionActiveClass,accordionBodySelector,accordionTogglerSelector});
        this._accordionBtnClose = Boolean(accordionBtnCloseSelector) ? accordion.querySelector(accordionBtnCloseSelector) : null,
        this._accordionTogglerArr = Array.from(document.querySelectorAll(accordionTogglerSelector));
        this._accordionTogglerActiveClass = Boolean(accordionTogglerActiveClass) ? accordionTogglerActiveClass : null;
        this._isOpen = false;
        this._renderer = renderer;
    }

    _open() {
        super._open();
        this._isOpen = true;
        this._renderer({
            isOpen: this._isOpen,
            accordion: this._accordion
        });
    }

    _close() {
        super._close();
        this._isOpen = false;
        this._renderer({
            isOpen: this._isOpen,
            accordion: this._accordion
        });
    }

    setEventListeners() {
        if(this._accordionTogglerArr.length) {
            this._accordionTogglerArr.forEach((accordionToggler, index, arr) => {
                accordionToggler.addEventListener('click', (e) => {
                    this._toggle();
                    for(let i = 0; i < arr.length; i++) {
                        arr[i].classList.toggle(this._accordionTogglerActiveClass);
                    }
                });
            });
        }

        if(this._accordionBtnClose) {
            this._accordionBtnClose.addEventListener('click', (e) => {
                this._close();
                this._accordionTogglerArr.forEach(accordionToggler => {
                    accordionToggler.classList.remove(this._accordionTogglerActiveClass);
                });
            });
        }
    }
}